export const AUTH_ERROR_MESSAGE_KEYS = {
  AUTH_EMAIL_REQUIRED: 'auth:errors.emailRequired',
  AUTH_EMAIL_INVALID: 'auth:errors.emailInvalid',
  AUTH_EMAIL_DOMAIN_CANNOT_RECEIVE: 'auth:errors.emailDomainCannotReceive',
  AUTH_EMAIL_SUPPRESSED: 'auth:errors.emailSuppressed',
  AUTH_CODE_REQUIRED: 'auth:errors.codeRequired',
  AUTH_CODE_EXPIRED: 'auth:errors.codeExpired',
  AUTH_CODE_TOO_MANY_ATTEMPTS: 'auth:errors.codeTooManyAttempts',
  AUTH_CODE_INVALID: 'auth:errors.codeInvalid',
  AUTH_TOKEN_REQUIRED: 'auth:errors.tokenRequired',
  AUTH_VERIFICATION_EXPIRED: 'auth:errors.verificationExpired',
  AUTH_PASSWORD_TOO_SHORT: 'auth:errors.passwordTooShort',
  AUTH_INVALID_CREDENTIALS: 'auth:errors.invalidCredentials',
  AUTH_INVALID_EMAIL: 'auth:errors.invalidEmail',
  AUTH_GOOGLE_EMAIL_ALREADY_LINKED: 'auth:errors.googleEmailAlreadyLinked',
  AUTH_APPLE_EMAIL_MISSING: 'auth:errors.appleEmailMissing'
};

export function resolveAuthErrorMessageKey(code) {
  if (typeof code !== 'string') {
    return '';
  }

  return AUTH_ERROR_MESSAGE_KEYS[code.trim()] || '';
}

export function resolveAuthApiErrorMessage(error, t, fallbackKey) {
  const key = resolveAuthErrorMessageKey(error?.payload?.code);
  return key ? t(key) : t(fallbackKey);
}
